/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import PropTypes from 'prop-types';
import { ImStarFull } from 'react-icons/im';
import { css } from '@emotion/css';
import colorStyles from '../enums/colorStyles';
import useResponse from '../hooks/useResponse';
import getRatings from '../utils/getRatings';
import Question from './Question';

const StarRating = ({
  question,
  responseForQuestion,
  id,
  isMandatory,
  minRatingValue,
  ratingInterval,
  questionTextFormat,
  numberOfIntervals,
}) => {
  const { answer: ratingAnswer } = responseForQuestion;
  const [rating, setRating] = useState(ratingAnswer);
  const [hoveredRating, setHoveredRating] = useState(null);
  const { saveFeedbackResponse } = useResponse();

  const onClickHandler = (value) => {
    setRating(value);
    saveFeedbackResponse({ id, answer: value });
  };

  const ratings = getRatings(minRatingValue, ratingInterval, numberOfIntervals);

  const setColour = (colorValue, ratingValue) =>
    rating >= ratingValue || hoveredRating >= ratingValue
      ? colorValue
      : colorStyles.DEFAULT;

  return (
    <Column spacingInset="xxsmall">
      <Question
        questionTextFormat={questionTextFormat}
        question={question}
        isMandatory={isMandatory}
      />
      <Row>
        {ratings.map((ratingVal) => (
          <label
            className={css`
              & > svg {
                transition: color 0.5s ease-in-out;
              }
              &:hover {
                transform: scale(1.5);
                transition: all 0.2s ease-in-out;
              }
            `}>
            <input
              type="radio"
              onClick={() => onClickHandler(ratingVal)}
              className={css`
                & {
                  display: none;
                }
              `}
            />
            <ImStarFull
              aria-label={`star${ratingVal}`}
              size={50}
              color={setColour(colorStyles.STAR, ratingVal)}
              onMouseEnter={() => setHoveredRating(ratingVal)}
              onMouseLeave={() => setHoveredRating(null)}
              style={{ cursor: 'pointer' }}
            />
          </label>
        ))}
      </Row>
    </Column>
  );
};

StarRating.propTypes = {
  question: PropTypes.string.isRequired,
  responseForQuestion: PropTypes.object,
  id: PropTypes.string.isRequired,
  isMandatory: PropTypes.bool.isRequired,
  minRatingValue: PropTypes.number,
  ratingInterval: PropTypes.number,
  questionTextFormat: PropTypes.string,
  numberOfIntervals: PropTypes.number,
};

StarRating.defaultProps = {
  minRatingValue: 1,
  responseForQuestion: { answer: null },
  ratingInterval: 1,
  questionTextFormat: '',
  numberOfIntervals: 5,
};

export default StarRating;
